export type RelatedGuide = {
  id: string;
  title: string;
  description: string;
  href: string;
};

export const RESIDENTIAL_RELATED_GUIDES: RelatedGuide[] = [
  {
    id: "scraping-amazon",
    title: "Best Proxies for Scraping Amazon",
    description:
      "Compare residential proxy providers for authorized Amazon product, price, and seller data collection.",
    href: "/blog/best-proxies-for-scraping-amazon/",
  },
  {
    id: "scraping-walmart",
    title: "Best Proxies for Scraping Walmart",
    description:
      "Compare residential proxy providers for Walmart price monitoring, stock tracking, and market research.",
    href: "/blog/best-proxies-for-scraping-walmart/",
  },
];
